<div class="feedback-block mb-1">
  <app-icon [icon]="iconClass"></app-icon>
  <h3 class="feedback-block__title">{{ title }}</h3>
  <div class="feedback-block__description" *ngIf="description">{{ description }}</div>
  <ng-content></ng-content>
</div>
